import React from 'react';

// components
import { Button, Card, CardBody, CardFooter, Row, Col } from "reactstrap";

export default function VistoriaOnlineListaInspecoes({ boletimVistoriaInspecoes }) {

    return (
        <>
            <Row>
                {boletimVistoriaInspecoes && boletimVistoriaInspecoes.map((m, key) => (
                    <Col lg="4" md="6" sm="12" key={key}>
                        <Card className="mt-4">
                            <CardBody>
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <h5 className="subtitleCard">{"Inspeção " + (key + 1) + " (" + m.local + ")"}</h5>
                                    </Col>
                                    <Col lg="12" md="12" sm="12">
                                        <strong>CEP: </strong><span>{m.cep}</span>
                                    </Col>
                                    <Col lg="12" md="12" sm="12">
                                        <strong>Endereço: </strong><span>{m.logradouro + ", " + m.numero}</span>
                                    </Col>
                                    <Col lg="12" md="12" sm="12">
                                        <strong>Bairro: </strong><span>{m.bairro}</span>
                                    </Col>
                                </Row>
                            </CardBody>
                            {/* <CardFooter className="text-center">
                                <Button className="btn-link text-info"><i className="fas fa-search"></i> Visualizar Questionário</Button>
                            </CardFooter> */}
                        </Card>
                    </Col>
                ))}
            </Row>
        </>
    );
}

